import { Stack, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { buildItemCardLines, ItemCardData } from './itemCardFormatters';
import { UsageSummaryPill } from './UsageSummaryPill';
import { ProductThumbnail } from './ProductThumbnail';

export type ProductCardItem = ItemCardData & {
  thumbnailUrl?: string | null;
  name?: string | null;
  sku?: string | null;
  gtin?: string | null;
  isFrozen?: boolean | null;
};

export const ProductCard = ({ item, currencyCode, showMessageWhenNoCost }: { item: ProductCardItem; currencyCode?: string; showMessageWhenNoCost?: boolean }) => {
  const { t } = useTranslation('orderForm');
  const itemNumber = item.sku;
  const lines = buildItemCardLines(item, currencyCode, {
    order: t('itemCardOrderLabel'),
    onOrder: t('itemCardOnOrderLabel'),
    onHand: t('itemCardOnHandLabel'),
  }, { showMessageWhenNoCost });

  return (
    <Stack direction="row"
      spacing={4}
      sx={{ alignItems: 'center', minWidth: 0 }}>
      <ProductThumbnail thumbnailUrl={item.thumbnailUrl}
        itemNumber={itemNumber} />
      <Stack spacing={0.75}
        sx={{ minWidth: 0, flex: 1, justifyContent: 'center' }}>
        <Tooltip title={item.name ?? ''}
          arrow>
          <Typography
            variant="textXS"
            sx={{
              fontWeight: 600,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {item.isFrozen ? '❄️ ' : ''}{item.name}
          </Typography>
        </Tooltip>
        {lines.map((line) => (
          <Typography
            key={line}
            variant="textXS"
            sx={{
              display: 'block',
              fontWeight: 400,
              lineHeight: 1.4,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {line}
          </Typography>
        ))}
        <UsageSummaryPill item={item} />
      </Stack>
    </Stack>
  );
};

export default ProductCard;
